export default class t {
  constructor() {}
  N(a) {}
  changeUser(a = !1) {}
  clearData(a = !1) {}
}
